module.exports = __webpack_public_path__ + "img/nodata.af675435.png";